import SEO from "../designSystem/SEO";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import BuyToLetImage from "../../assets/images/buy-to-let_mortgages_01.png";
import { ReactComponent as AccessIcon } from "../../assets/icons/capc_icons_access.svg";
import { ReactComponent as PersonalIcon } from "../../assets/icons/capc_icons_personalised_advice.svg";
import { ReactComponent as ProfessionalIcon } from "../../assets/icons/capc_icons_end-to-end_support.svg";
import Hero from "../designSystem/Hero";

const highlights = [
  {
    title: "Tailored Advice",
    icon: PersonalIcon,
    text: "Guidance for first-time landlords, portfolio landlords and limited company buy-to-let applications.",
  },
  {
    title: "Access",
    icon: AccessIcon,
    text: "90+ UK lenders including specialist buy-to-let lenders and private banks.",
  },
  {
    title: "End-to-End Support",
    icon: ProfessionalIcon,
    text: "We manage the paperwork, liaise with lenders and keep you informed every step of the way.",
  },
];

const BuytoLetMortgagesPage = () => (
  <main>
    <SEO
      title="Buy-to-Let Mortgage Advice"
      description="Tailored buy-to-let mortgage advice for first-time landlords, experienced investors and limited companies."
      path="/buy-to-let-mortgages"
    />
    <Hero wantOverlay={false}>
      <div className="content-container">
        <div className="column gap-m align-center">
          <div className="nav-text text-secondary-1 uppercase">Our services</div>
          <h1 className="text-primary-1 text-center">Buy-to-Let Mortgages</h1>
          <div className="content text-primary-2 text-center">
            A buy-to-let mortgage is designed for people purchasing a property
            to rent out rather than live in themselves. Whether you're buying
            your first investment property or expanding an existing portfolio,
            the right mortgage can help maximise your returns and support your
            long-term investment goals.
          </div>
          <PrimaryButtonSmall text="contact us" />
        </div>
      </div>
    </Hero>

    <section className="background-container bg-white">
      <div className="content-container grid2 gap-xxxxxl grid-stretch">
        <img
          src={BuyToLetImage}
          alt="Apartment building representing a buy-to-let property investment"
          className="hero-image"
        />
        <div className="column gap-l">
          <h3 className="text-primary-2">
            Why Choose CAPC for Buy-to-Let Mortgages?
          </h3>{" "}
          <div className="column gap-m">
            <div className="content text-primary-2">
              At CAPC Mortgages, we provide tailored advice for both first-time
              landlords and experienced property investors. With access to over
              90 UK lenders, including specialist buy-to-let providers and
              private banks, we can source mortgage solutions that match your
              investment strategy.
            </div>
            <div className="content text-primary-2">
              Buy-to-let lending is often more complex than a standard
              residential mortgage. Lenders will typically assess factors such
              as expected rental income, your existing property portfolio and
              your overall financial position. With a wide range of products and
              criteria available, finding the most suitable deal requires
              specialist knowledge.
            </div>
          </div>
          <div className="body1 text-primary-2">
            The Financial Conduct Authority does not regulate most buy to let
            mortgages.
          </div>
        </div>
      </div>
    </section>

    <section className="background-container bg-primary-2">
      <div className="content-container grid3 gap-xxxxl">
        {highlights.map(({ title, icon: Icon, text }) => (
          <article className="column gap-xl align-center" key={title}>
            <Icon aria-hidden="true" />
            <div className="column gap-m align-center">
              <div className="subtitle-semibold text-white text-center">
                {title}
              </div>
              <div className="content text-white text-center">{text}</div>
            </div>
          </article>
        ))}
      </div>
    </section>

  </main>
);

export default BuytoLetMortgagesPage;
